import React from "react";
import { IoMdSearch } from "react-icons/io";

const SearchFilter = ({ value, onChange, placeholder = "Search", maxWidthClass = "max-w-250" }) => {
  return (
    <div
      className={`d-flex align-items-center ${maxWidthClass} flex-grow-1`}
      style={{ position: "relative" }}
    >
      <div className="floating-field mt-1" style={{ width: "100%" }}>
        <IoMdSearch
          size="1.1em"
          style={{
            position: "absolute",
            left: 10,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#4e545a",
          }}
        />
        <input
          type="text"
          className="input_styling"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{ width: "100%", paddingLeft: 30 }}
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default SearchFilter;
